// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HSvz","expireSoon":"styles_expireSoon__13I9u"};